import './playerProfile.css';
import React, { useContext } from 'react';
import { stylizeKeyword } from 'others/keywords/keywordstyles';
import { leftPlayerOf, rightPlayerOf } from 'others/game/utils';
import RoomProvider from 'components/Provider/RoomProvider';

function PlayerProfile(props) {
    const { room } = useContext(RoomProvider);
    const player = room.localPlayer;

    const name = stylizeKeyword(`player=${player.name};`);
    const role = player.role? stylizeKeyword(`[${player.role?.name}]`) : '';
    const diamond = player.diamondCount + ' ' + stylizeKeyword('[diamond]');
    
    var leftPlayer = leftPlayerOf(player, room.players)?.name;
    leftPlayer = stylizeKeyword(`player=${leftPlayer};`);

    var rightPlayer = rightPlayerOf(player, room.players)?.name;
    rightPlayer = stylizeKeyword(`player=${rightPlayer};`);

    return (
        <div id='pp_container'>
            <div id="pp_infos">
                <h3 className='pp_field'>
                    Nom : <span dangerouslySetInnerHTML={{__html: name}}/>
                </h3>
                <h3 className='pp_field'>
                    Rôle : <span dangerouslySetInnerHTML={{__html: role}}/>
                </h3> 
                <h3 className='pp_field'>
                    Poche : <span dangerouslySetInnerHTML={{__html: diamond}}/>
                </h3>     
                <h3 className='pp_field'>
                    Joueur avant vous : <span dangerouslySetInnerHTML={{__html: leftPlayer}}/>
                </h3>     
                <h3 className='pp_field'>
                    Joueur après vous : <span dangerouslySetInnerHTML={{__html: rightPlayer}}/>
                </h3> 
                <h3 className='pp_field'>
                    Jokers restants pour le parrain : { room.players[room.playingPlayerIndex].joker }
                </h3> 
            </div>            
        </div>
    );
}

export default PlayerProfile;